export default class Article {
    id!: number;
    title!: string;
    content!: string;
    description!: string;
    authorOrganizationName!: string;
    authorName!: string;
    type!: ArticleType;
    isTop!: boolean;
    isShow!: boolean;
    coverUrl!: string;
    createdTime!: string;
    updatedTime!: string;
    publishedTime!: string;

    constructor(source?: any) {
        if (source) {
            Object.assign(this, source);
        }
    }
}

export type ArticleType = '研究院介绍' | '课程体系' | '研究报告';
